import React from "react";
import PolicyPage, { ContactEmail } from "./PolicyPage";

function WarrantyPolicy() {
  return (
    <PolicyPage title="Product Warranty Policy">
      <h2>Warranty coverage</h2>
      <p>A product is covered by the express warranty stated on its product page or packaging, if any, and by mandatory statutory guarantees. If no separate written warranty period is stated, this policy does not create an additional fixed-duration commercial warranty.</p>

      <h2>What a valid claim may cover</h2>
      <p>Coverage may apply to a defect in materials or workmanship that existed at delivery or arose during an expressly stated warranty period under normal household use. A remedy may include repair, replacement, a price reduction, or refund, depending on the issue, product, availability, and applicable law.</p>

      <h2>What is not normally covered</h2>
      <ul>
        <li>ordinary wear, cosmetic variation, or natural differences in wood, clay, stone, glaze, or other natural materials;</li>
        <li>accident, impact, misuse, commercial use, unauthorized modification, or improper assembly;</li>
        <li>damage from unsuitable heat, cold, dishwasher, microwave, oven, chemicals, or storage contrary to instructions;</li>
        <li>consumable parts, staining, odor, discoloration, or scratching that does not affect intended function; or</li>
        <li>loss or damage after an unauthorized repair or use with incompatible accessories.</li>
      </ul>

      <h2>Making a claim</h2>
      <p>Stop using an item that may be unsafe. Email the order number, product name, description of the issue, when it began, and clear photographs or video. We may request reasonable troubleshooting or inspection and will provide return instructions if needed.</p>

      <h2>Consumer rights</h2>
      <p>This policy does not exclude, reduce, or replace any warranty, conformity right, or remedy that cannot legally be limited.</p>

      <h2>Contact</h2>
      <p>Warranty claims may be sent to <ContactEmail />.</p>
    </PolicyPage>
  );
}

export default WarrantyPolicy;
